import React, { useEffect, useState } from 'react';
import useShops from '../../services/shops';
import { IoMdPin } from 'react-icons/io'
import { useTransition, config } from '@react-spring/web';
import ShopRow from './shop-row';
import { useAppState } from '../../providers/app-state'
import CustomInput from '../../components/custom-input';
import { location_geolocation_button_text, location_step_heading } from '../../lang/da';
import ConsentInfoBlock from '../../components/consent-info-block';


const LocationScreen = ({ goNext }) => {
    const { dispatch, state } = useAppState()
    const { shops, getShops, isLoading, getShopsWithZip, getShopsWithGeo, getShopsByBrand } = useShops();
    const [searchValue, setSearchValue] = useState("");
    const [showByd, setShowByd] = useState(false);

    const transition = useTransition(shops || [], {
        config: config.stiff,
        trail: 700 / shops.length,
        from: {
            opacity: 0,
            scale: 0.5,
        },
        enter: {
            opacity: 1,
            scale: 1,
        }
    })

    useEffect(() => {
        getShops();
    }, [getShops])

    useEffect(() => {
        if (showByd) {
            getShopsByBrand("byd")
        } else {
            getShops();
        }
    }, [showByd])

    const getGeoLocation = () => {
        navigator.geolocation.getCurrentPosition(position => {
            setSearchValue("");
            getShopsWithGeo({ lat: position.coords.latitude, lng: position.coords.longitude })
        })
    }

    const onChange = (value) => {
        if (!Number.isInteger(+value)) {
            return;
        }

        if (value.length > 4) {
            return;
        }

        if (value.length === 4) {
            getShopsWithZip(value)
        }

        setSearchValue(value);
    }

    return (
        <div
            className="py-12 md:py-20 space-y-10"
        >
            <div
                className='space-y-5'
            >
                <h1
                    className='text-3xl md:text-4xl font-light'
                >
                    {
                        location_step_heading
                    }
                </h1>
                <div
                    className='flex flex-row space-x-2 md:space-x-4'
                >
                    <CustomInput
                        as={<input />}
                        placeholder="6000"
                        labelText="Postnummer"
                        onChange={e => onChange(e.target.value)}
                        value={searchValue}
                    />
                    <button
                        className="flex flex-row items-center rounded-md space-x-1"
                        onClick={getGeoLocation}
                    >
                        <span
                            className='text-xs'
                        >
                            {
                                location_geolocation_button_text
                            }
                        </span>
                        <IoMdPin
                            className='text-skgRed'
                            size={20}
                        />
                    </button>
                    <div
                        className="flex items-center"
                    >
                        <label htmlFor="filterByd" className="text-sm">
                            <input id="filterByd" type="checkbox" className="mr-2 accent-skgBlue" value={showByd} name="" onChange={(event) => {
                                setShowByd(event.target.checked)
                            }} />
                            Se kun BYD værksteder
                        </label>
                    </div>
                </div>
            </div>
            <div
                className='mt-4 flex flex-col'
            >
                {
                    transition((style, item) => {
                        return (
                            <ShopRow
                                active={state.selectedShop && state.selectedShop.name === item.name}
                                key={item.id}
                                loading={isLoading}
                                onClick={() => {
                                    dispatch({
                                        key: "selectedShop",
                                        value: item
                                    });
                                    goNext();
                                }}
                                style={style}
                                shopObj={item}
                            />
                        )
                    })
                }
            </div>
            <ConsentInfoBlock />
        </div>
    )
}

export default LocationScreen;